// extracted by mini-css-extract-plugin
module.exports = {"popover-component":"styles_popover-component__EX-Le","popover":"styles_popover__17c_q","pop":"styles_pop__3DXJU"};